import { useEffect, useMemo } from 'react';
import dayjs from 'dayjs';
import { useAnalyticsOrgLocations, useTimePeriodDropDownSelector, findDatesRange } from '@frontend/analytics-shared';
import { useAppointmentAnalyticsV2ShallowStore } from './use-appointment-analytics-v2-store';
import { useIsAppointmentDemoAccount } from './use-is-appointment-demo-account';

export const useInitializeFilters = () => {
  const { initialize } = useAppointmentAnalyticsV2ShallowStore('initialize');

  const isDemoAccount = useIsAppointmentDemoAccount();

  const { preselectedAccessibleLocationIds } = useAnalyticsOrgLocations({
    isDemoAccount,
    module: 'APPOINTMENT',
  });

  const { defaultStartDate: pastStartDate, defaultEndDate: pastEndDate } = useTimePeriodDropDownSelector({
    defaultPeriod: 'last30Days',
    values: {
      startDate: undefined,
      endDate: undefined,
    },
  });

  const upcomingDateRange = useMemo(() => findDatesRange({ offset: 7, range: 'day', type: 'future' }), []);

  useEffect(() => {
    if (preselectedAccessibleLocationIds?.length) {
      initialize(
        {
          locationId: preselectedAccessibleLocationIds,
          startDate: dayjs(pastStartDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS'),
          endDate: dayjs(pastEndDate).endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS'),
        },
        {
          locationId: preselectedAccessibleLocationIds,
          startDate: dayjs(upcomingDateRange.startDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS'),
          endDate: dayjs(upcomingDateRange.endDate).endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS'),
        }
      );
    }
  }, [preselectedAccessibleLocationIds, pastStartDate, pastEndDate, upcomingDateRange, initialize]);
};
